<!-- Dialog: FILTER NEW-->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="false"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-normal"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <div fxLayoutWrap fxLayout="column">
    <div fxLayout="row" fxFlexFill>
      <div fxFlex class="p-autocomplete-float-group">
        <bfx-text-input
          #copyFilter_filterName_autoComplete
          [(ngModel)]="data.dialogData.autocomplete_filterName"
          field="label"
          size="sm"
          inputLabelText="Favourite Name"
          (ngModelChange)="helperCreateFilter_validateFilterName($event)"
          autoHighlight="true"
          autoComplete="off"
          [maxLength]="50"
          [style]="{'width':'100%'}"
        >
        </bfx-text-input>
        <span class="p-autocomplete-float-highlight"></span>
        <div
          class="p-autocomplete-float-label-error"
          [ngStyle]="{ visibility: filterNameValid || filterNameEmpty ? 'hidden' : 'visible'}"
        >
          {{data.dialogData.message_text_invalid}}
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <button
      pButton
      type="button"
      class="bfx-button-secondary-subtle"
      (click)="actionCreateFilter_close()"
      label="Cancel"
    ></button>
    <button
      pButton
      type="button"
      class="bfx-button-primary"
      (click)="actionCreateFilter_confirm()"
      label="Create"
      [disabled]="!data.dialogData.autocomplete_filterName || !filterNameValid"
    ></button>
  </p-footer>
</p-dialog>
